import { useMutation, useQuery } from '@tanstack/react-query';
import { getTimezone } from '@mgm/common/utils';
import { PosOrdersController } from '../../../services';
import { DEFAULT_LOCATION_ID } from '../../../data';
import { QUERY_KEYS } from '../../../utils/enums';
import { TGetStaffRes } from '../../../types/responses/pos.type';
import { useAppDispatch } from '../../useAppStore';
import { posActions } from '../../../store/pos/slice';
import { IBaseResponse, TAxiosError } from '../../../types/responses';
import { TSetAttributeReq } from '../../../types/requests';
import { useError } from '../../useCommon';

export function useGetStaffAPI(shopName: string, locationId: string | null) {
  const dispatch = useAppDispatch();
  const { handleReqError } = useError();

  const data = {
    shopName,
    locationIds: [DEFAULT_LOCATION_ID, Number(locationId)],
  };

  return useQuery([QUERY_KEYS.POS.ORDERS], async () => {
    const rsp = await PosOrdersController().getStaff<TGetStaffRes>(data);

    if (rsp.success && 'staff' in rsp) {
      dispatch(posActions.setStaff(rsp.staff));
    } else if (rsp?.error && rsp.error?.response?.status) {
      handleReqError(rsp.error, data);
    } else if ('msg' in rsp) {
      console.error(`ERROR! get staff failed! ${rsp.msg}`);
    }

    return rsp;
  }, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}

export function useSetAttributeAPI() {
  const { handleReqError } = useError();

  const setAttributeApi = (payload: TSetAttributeReq) => {
    const data = {
      ...payload,
      timezone: getTimezone(),
    };

    return PosOrdersController().setAttribute<IBaseResponse>(data);
  };

  return useMutation(setAttributeApi, {
    onSuccess: (rsp, variables) => {
      if (!rsp.success && 'msg' in rsp) {
        console.error(`ERROR! set attribute failed! ${rsp.msg}`);
      } else if (rsp?.error && rsp.error?.response?.status) {
        handleReqError(rsp.error, variables);
      }

      return rsp;
    },
    onError: (error: TAxiosError) => {
      console.error(`ERROR! set attribute request threw an Exception! ${error}`);
    },
  });
}
